import { FC } from 'react'
import { Typography, Badge, Row, Icon } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import Image from 'next/image'
import { UserReferralStats } from '@repo/services'
import { InviteDetailsDialog } from './invite-details.dialog'
import { useIsDesktop } from '@repo/ui/hooks'
import { LevelsBadge, ToDate, ValueWithUnit } from '@repo/shared/components'
import { cn } from '@repo/ui/lib'

export const InviteItem: FC<{
  item: UserReferralStats
  forceMobileStyle?: boolean
}> = ({ item, forceMobileStyle = false }) => {
  const { t } = useTranslate()
  const _isDesktop = useIsDesktop()
  const isDesktop = forceMobileStyle ? false : _isDesktop
  return (
    <InviteDetailsDialog {...item}>
      <div
        className={cn(
          ' flex flex-row items-center    w-full  border-b border-neutral-surface-30 last:border-0',
          !forceMobileStyle && 'md:items-[unset]',
        )}
      >
        <div
          className={cn(
            'flex flex-row gap-sm items-center w-full  ',
            !forceMobileStyle && 'md:w-fit',
          )}
        >
          <div className='w-full md:min-w-[200px] p-sm whitespace-nowrap flex flex-col justify-between gap-sm rtl:text-right ltr:text-left '>
            <Row className='gap-xs items-center w-fit'>
              <Typography
                dir='ltr'
                size='xs'
                weight='bold'
                color='text-neutral-surface-100'
              >
                {item?.maskedPhone
                  ? item?.maskedPhone?.replace('+98', '0')
                  : item?.maskedEmail}
              </Typography>
              {item.userType === 'user' && (
                <>
                  {item.kyc ? (
                    <LevelsBadge noNumber level={(item.userLevel ?? 0) + 1} />
                  ) : (
                    <Badge
                      color={'alert'}
                      size='sm'
                      variant='custom'
                      className='text-alert-surface-100 gap-2xs flex items-center'
                    >
                      <Icon
                        color='fill-alert-main'
                        name='AlertTriangle'
                        className='w-4 h-4'
                      />{' '}
                      {t('inviteTable_label_kyc_pending')}
                    </Badge>
                  )}
                </>
              )}
              {item.userType === 'agent' ? (
                <Badge color='base' variant='liquid' size='md'>
                  {t('common_level_5_description')}
                </Badge>
              ) : undefined}
            </Row>
            <Typography size='xs' color='text-neutral-surface-80' variant='bdi'>
              <ToDate date={new Date(item.joinedAt ?? '')} />
            </Typography>
          </div>
          <div className=' w-full p-sm gap-xs whitespace-nowrap '>
            <div
              className={cn(
                'flex flex-col    justify-between  items-end  gap-xs ',
                !forceMobileStyle &&
                  'md:flex-row md:justify-center md:items-center',
              )}
            >
              {isDesktop && (
                <>
                  {item.trades ? (
                    <Typography
                      size='xs'
                      weight='regular'
                      color='text-neutral-surface-100'
                    >
                      {item.trades +
                        ' ' +
                        t('inviteTable_label_tradeCount_title')}
                    </Typography>
                  ) : (
                    <Badge
                      color={'alert'}
                      size='sm'
                      variant='custom'
                      className='text-alert-surface-100 gap-2xs flex items-center'
                    >
                      <Icon
                        color='fill-alert-main'
                        name='AlertTriangle'
                        className='w-4 h-4'
                      />{' '}
                      {t('inviteTable_label_tradeCount_none')}
                    </Badge>
                  )}
                </>
              )}

              {!isDesktop && (
                <div
                  className={cn(
                    ' w-full flex flex-col gap-sm  whitespace-nowrap rtl:text-left ltr:text-right',
                    forceMobileStyle && 'w-full',
                  )}
                >
                  <div
                    className={cn(
                      'flex flex-row  justify-between  gap-xs ',
                      !forceMobileStyle && 'md:flex-col md:justify-center ',
                    )}
                  >
                    <Row className='justify-end w-full   items-center gap-xs '>
                      <ValueWithUnit
                        value={item.totalEarned}
                        showZero={false}
                        // unit='SQ2'
                        valueSize='xs'
                        valueColor='text-neutral-surface-100'
                        unitColor='text-neutral-surface-100'
                        unitSize='xs'
                        valueWeight='bold'
                      />
                      <Image
                        src='/images/club-gem.svg'
                        alt='coin'
                        width={20}
                        height={20}
                      />
                    </Row>
                  </div>
                  <div
                    className={cn(
                      'flex flex-row  justify-between  gap-xs ',
                      !forceMobileStyle && 'md:flex-col md:justify-center ',
                    )}
                  >
                    <Row className='justify-end w-full   items-center gap-xs '>
                      <Typography size='xs' color='text-neutral-surface-60'>
                        {t('inviteTable_header_subCoins')}
                      </Typography>

                      <ValueWithUnit
                        value={item.received}
                        showZero={false}
                        unit='SQ2'
                        valueSize='xs'
                        valueColor='text-neutral-surface-100'
                        unitColor='text-neutral-surface-100'
                        unitSize='xs'
                        valueWeight='regular'
                        unitPosition='before'
                      />
                      {/* <Image
                        src='/images/club-gem.svg'
                        alt='coin'
                        width={20}
                        height={20}
                      /> */}
                    </Row>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {isDesktop && (
          <div
            className={cn(
              ' w-full p-sm gap-sm flex flex-col whitespace-nowrap rtl:text-left ltr:text-right ',
              forceMobileStyle && 'w-full',
            )}
          >
            <div
              className={cn(
                'flex flex-row  justify-between   gap-xs ',
                !forceMobileStyle && 'md:flex-col md:justify-center',
              )}
            >
              <Row className='justify-end w-full   items-center gap-xs '>
                <ValueWithUnit
                  value={item.totalEarned}
                  showZero={false}
                  // unit='SQ2'
                  valueSize='xs'
                  valueColor='text-neutral-surface-100'
                  unitColor='text-neutral-surface-100'
                  unitSize='xs'
                  valueWeight='bold'
                />
                <Image
                  src='/images/club-gem.svg'
                  alt='coin'
                  width={20}
                  height={20}
                />
              </Row>
            </div>
            <div
              className={cn(
                'flex flex-row  justify-between   gap-xs ',
                !forceMobileStyle && 'md:flex-col md:justify-center',
              )}
            >
              <Row className='justify-end w-full   items-center gap-xs '>
                <Typography size='xs' color='text-neutral-surface-60'>
                  {t('inviteTable_header_subCoins')}
                </Typography>

                <ValueWithUnit
                  value={item.received}
                  showZero={false}
                  unit='SQ2'
                  valueSize='xs'
                  valueColor='text-neutral-surface-100'
                  unitColor='text-neutral-surface-100'
                  unitSize='xs'
                  valueWeight='regular'
                  unitPosition='before'
                />
                {/* <Image
                  src='/images/club-gem.svg'
                  alt='coin'
                  width={20}
                  height={20}
                /> */}
              </Row>
            </div>
          </div>
        )}

        <Icon
          name='ChevronLeftLine'
          size='sm'
          color='fill-neutral-surface-20'
          className={cn(
            'hidden  cursor-pointer',
            !forceMobileStyle && 'md:block',
          )}
        />
      </div>
    </InviteDetailsDialog>
  )
}
